<template>
  <adminTable
    ref="adminTableRef"
    :tableLoading="tableLoading"
    :totalList="totalList"
    v-model:page="page"
    v-model:limit="limit"
    v-model:searchForm="searchForm"
    :tableData="tableData"
    @search="getList"
  >
    <template v-slot:form-inline-items>
      <el-form-item>
        <el-input v-model="searchForm.title" placeholder="搜索标题" clearable />
      </el-form-item>
      <el-form-item>
        <el-select v-model="searchForm.status" placeholder="状态" clearable>
          <el-option
            v-for="item in saleStatusEnums"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
    </template>
    <template v-slot:query-button-right>
      <el-button
        type="primary"
        icon="CirclePlus"
        @click="editItem('add', {})"
        v-permission
        >添加</el-button
      >
    </template>
    <template v-slot:table>
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="sort" sortable label="排序" width="80" />
      <el-table-column prop="title" label="标题" width="150" />
      <el-table-column prop="class_name" label="分类" width="160" />
      <el-table-column prop="status" label="状态" width="200">
        <template #default="scope">
          {{ getLabelByVal(scope.row.status, saleStatusEnums) }}
        </template>
      </el-table-column>
      <el-table-column prop="img" label="图片" width="200">
        <template #default="scope">
          {{ scope.row.img ? "" : "--" }}
          <el-image
            v-if="scope.row.img"
            class="previewImg"
            :preview-teleported="true"
            :src="proxy.IMG_BASE_URL + scope.row.img"
            :zoom-rate="1.2"
            :max-scale="7"
            :min-scale="0.2"
            :preview-src-list="[proxy.IMG_BASE_URL + scope.row.img]"
            show-progress
            :initial-index="0"
            fit="cover"
          />
        </template>
      </el-table-column>
      <el-table-column prop="sales_fake" label="虚拟销量" width="120" />
      <el-table-column prop="invest" label="起投金额" width="200" />
      <el-table-column prop="invest_limit" label="限投次数" width="120" />
      <el-table-column prop="profit_rate" label="利率(%)" width="200" />
      <el-table-column prop="profit_cycle" label="周期" width="200" />
      <el-table-column prop="sales_limit" label="销售限制" width="200" />
      <el-table-column prop="sales_time" label="销售时间" width="200" />
      <el-table-column prop="is_new" label="新人购买" width="120">
        <template #default="scope">
          <span>{{ scope.row.is_new == 0 ? '关闭' : scope.row.is_new == 1 ? '开启' : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sales_all" label="销售总量" width="120" />
      <el-table-column prop="gift_push" label="推三反一奖励" width="120" />
      <el-table-column prop="gift_referral_rate" label="下级推荐奖励(%)" width="140" />
      <el-table-column prop="gift_coupon" label="积分兑换券" width="120">
         <template #default="scope">
          <span>{{ scope.row.gift_coupon == 0 ? '关闭' : scope.row.gift_coupon == 1 ? '开启' : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="level" label="可购买的用户等级" width="150">
        <template #default="scope">
          {{
            levelList.filter((item) => item.id == scope.row.level).length > 0
              ? levelList.filter((item) => item.id == scope.row.level)[0].title
              : ""
          }}
        </template>
      </el-table-column>

      <el-table-column prop="home_display" label="首页展示" width="160">
        <template #default="scope">
          <span>{{ getLabelByVal(scope.row.home_display, booleanEnums) }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="progress" label="项目进度" width="200" /> -->
      <!-- <el-table-column
        prop="progress_rate"
        label="项目进度更新速率"
        width="200"
      /> -->
      <el-table-column
        prop="product_release_time"
        label="商品发布时间"
        width="160"
      />
      <!-- <el-table-column
        prop="product_insurance_time"
        label="商品投保时间"
        width="160"
      /> -->
      <el-table-column prop="gift_points" label="奖励积分" width="200" />
      <!-- <el-table-column prop="gift_goods" label="赠送实物产品" width="160" /> -->
      <el-table-column prop="level_income" label="等级收益" width="160">
        <template #default="scope">
          <span>{{
            getLabelByVal(scope.row.level_income, levelIncomeEnums)
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="gift_product_expires"
        label="到期赠送现金"
        width="160"
      />

      <!-- <el-table-column prop="video_link" label="详情视频" width="160" /> -->

      <!-- <el-table-column
        prop="progress_cycle"
        label="项目进度更新周期"
        width="200"
      >
        <template #default="scope">
          {{ getLabelByVal(scope.row.progress_cycle, cycleTimeEnums) }}
        </template>
      </el-table-column> -->

      <el-table-column prop="create_at" label="添加时间" width="160" />
      <el-table-column
        label="操作"
        fixed="right"
        width="200"
        v-if="currentUser.role == 0"
      >
        <template #default="scope">
          <el-button
            type="primary"
            icon="Edit"
            v-permission
            @click="editItem('edit', scope.row)"
            >编辑</el-button
          >
          <el-button
            type="danger"
            icon="Delete"
            v-permission
            @click="deleteAction(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </template>
    <el-dialog v-model="dialogFlag" title="编辑/新增" width="1200">
      <editPop :key="editRow" ref="editFormRef" :item="editRow" />

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogFlag = false">关闭</el-button>
          <el-button type="primary" @click="submitForm"> 保存 </el-button>
        </div>
      </template>
    </el-dialog>
  </adminTable>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted } from "vue";
import {
  saleStatusEnums,
  levelIncomeEnums,
  cycleTimeEnums,
  getLabelByVal,
  booleanEnums,
} from "@/config/enums";
import EditPop from "./components/projectList/editPop.vue";
import { ElMessage, ElMessageBox } from "element-plus";

const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
const searchForm = ref({
  title: "",
  status: "",
});
const dialogFlag = ref(false);
const editRow = ref({});
const editFormRef = ref(null);
const adminTableRef = ref(null);
const formType = ref("add");

onMounted(() => {
  getList();
  getLevelList();
});

const levelList = ref([]);
const getLevelList = async () => {
  const res = await proxy.$http({
    method: "get",
    url: "/Level/getLevelLists",
  });
  if (res.code == 0) {
    levelList.value = [{ title: "普通会员", id: 0 }, ...res.data.data];
  }
};

const editItem = (type, row = {}) => {
  formType.value = type;
  editRow.value = row;
  dialogFlag.value = true;
};

const submitForm = async () => {
  const url = formType.value == "add" ? "item/addItem" : "item/updateItem";

  const data = editFormRef.value.form;
  if (!data.invest) {
    ElMessage({
      type: "error",
      message: '请填写投资金额',
    });
    return
  }
  if (!data.profit_rate) {
    ElMessage({
      type: "error",
      message: '请填写每期收益率',
    });
    return
  }
  
  if (!data.profit_cycle) {
    ElMessage({
      type: "error",
      message: '请填写项目周期',
    });
    return
  }

  if (formType.value == "add") {
    data.id = null;
  }
  const res = await proxy.$http({
    method: "post",
    url: url,
    data: {
      id: data.id,
      title: data.title,
      img: data.img,
      status: data.status,
      sort: data.sort,
      home_display: data.home_display,
      product_release_time: data.product_release_time,
      product_insurance_time: data.product_insurance_time,
      gift_goods: data.gift_goods,
      level_income: data.level_income,
      gift_product_expires: data.gift_product_expires,

      level: data.level,
      class_id: data.class_id,
      sales_fake: data.sales_fake,
      invest: data.invest,
      invest_scale: data.invest_scale,
      invest_limit: data.invest_limit,
      profit_type: data.profit_type,
      profit_rate: data.profit_rate,
      profit_more: data.profit_more,
      profit_cycle: data.profit_cycle,
      profit_cycle_time: data.profit_cycle_time,
      gift_points: data.gift_points,
      gift_raffle: data.gift_raffle,
      gift_bonus: data.gift_bonus,
      content: data.content,
      desc: data.desc,
      progress: data.progress,
      progress_cycle: data.progress_cycle,
      progress_rate: data.progress_rate,
      progress_time: data.progress_time,
      sales_limit: data.sales_limit,
      sales_time: data.sales_time,
      video_link: data.video_link,
      is_new: data.is_new,
      sales_all: data.sales_all,
      gift_push: data.gift_push,
      gift_coupon: data.gift_coupon,
      vip_level_income: data.vip_level_income,
      month_extra_profit: data.month_extra_profit,
      gift_free_product: data.gift_free_product,
      gift_referral_rate: data.gift_referral_rate,
      superior_income: data.superior_income,
      gift_energy: data.gift_energy,
      gift_cycle: data.gift_cycle,
      gift_cycle_money: data.gift_cycle_money,
      gift_cycle_money_more: data.gift_cycle_money_more,
      gift_cash_coupon: data.gift_cash_coupon,
      gift_rate_coupon: data.gift_rate_coupon,
      gift_words: data.gift_words,
      is_energy: data.is_energy,
      // coupon_limit: data.coupon_limit,
    },
  });

  if (res.code == 0) {
    dialogFlag.value = false;
    getList();
    ElMessage({
      type: "success",
      message: res.msg,
    });
  } else {
    dialogFlag.value = false;
    ElMessage({
      type: "error",
      message: res.msg,
    });
  }
};

const deleteAction = (row) => {
  ElMessageBox.confirm("是否删除?", "Warning", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(async () => {
      const res = await proxy.$http({
        method: "get",
        url: "item/deleteItem?id=" + row.id,
      });
      if (res.code == 0) {
        getList();
      }
      ElMessage({
        type: "success",
        message: res.msg,
      });
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "取消删除",
      });
    });
};

const { proxy } = getCurrentInstance();

const tableData = ref([]);
const page = ref(1);
const limit = ref(10);
const totalList = ref(0);
const tableLoading = ref(false);

const getList = async () => {
  tableLoading.value = true;
  const res = await proxy.$http({
    type: "get",
    url: "/Item/getItemLists",
    params: {
      page: page.value,
      limit: limit.value,
      ...searchForm.value,
    },
  });
  tableLoading.value = false;
  if (res.code == 0) {
    tableData.value = res.data.data.sort((a, b) => a.status - b.status);
    totalList.value = res.data.total;
  }
};
</script>

<style lang="less" scoped></style>
